import * as React from "react"
const SvgLayoutGrid = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5 9.568V5.575l.002-.002.001-.002h3.994l.001.002.002.002v3.993l-.002.002-.001.001H5.003l-.001-.001zm.003 10.003h3.994l.001-.001.002-.002v-3.993l-.002-.002-.001-.002H5.003L5 15.575v3.993l.002.002zM15 9.568V5.575l.002-.002.001-.002h3.994l.001.002.002.002v3.993l-.002.002-.001.001h-3.994l-.001-.001zm.003 10.003h3.994l.001-.001.002-.002v-3.993l-.002-.002-.001-.002h-3.994l-.001.002-.002.002v3.993l.002.002zM3.588 10.984q.587.588 1.412.587h4q.825 0 1.412-.587.588-.588.588-1.413v-4q0-.825-.588-1.412A1.93 1.93 0 0 0 9 3.57H5q-.824 0-1.413.588A1.93 1.93 0 0 0 3 5.57v4q0 .825.587 1.413Zm0 10q.587.587 1.412.587h4q.825 0 1.412-.587.588-.588.588-1.413v-4q0-.825-.588-1.412A1.93 1.93 0 0 0 9 13.57H5q-.824 0-1.413.588A1.93 1.93 0 0 0 3 15.57v4q0 .825.587 1.413Zm10-10q.587.587 1.412.587h4q.824 0 1.413-.587A1.93 1.93 0 0 0 21 9.571v-4q0-.824-.587-1.412A1.93 1.93 0 0 0 19 3.57h-4q-.825 0-1.412.588A1.93 1.93 0 0 0 13 5.57v4q0 .825.588 1.413Zm0 10q.587.587 1.412.587h4q.824 0 1.413-.587A1.93 1.93 0 0 0 21 19.571v-4q0-.825-.587-1.412A1.93 1.93 0 0 0 19 13.57h-4q-.825 0-1.412.588A1.93 1.93 0 0 0 13 15.57v4q0 .825.588 1.413Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgLayoutGrid
